/**
 * 「がんばりを いろに はんえいする」の せってい(docs/14_characters.md §2)。
 *
 * **既定はオフ = まっしろな パル**。オンにすると、直近28日の取り組みの比率で
 * パルの体色が混ざる(`logic/palColor.ts`)。設定はほかの設定と同じ
 * `paltyping.settings.v1` に入る(`services/settings.ts`)。
 *
 * きろく画面(せってい)と パルの ステータス画面の**両方**に置く
 * (色を見ている場所でそのまま切り替えられるほうが子どもには分かりやすい)。
 */

import { useGameStore } from '../store/gameStore';

export function PalColorSettings() {
  const on = useGameStore((state) => state.settings.reflectEffortColor);
  const toggle = useGameStore((state) => state.toggleEffortColor);

  return (
    <section className="card pal-settings">
      <h2 className="card-title">🎨 パルの いろ</h2>
      <label className={`pal-settings-check ${on ? 'on' : ''}`}>
        <input type="checkbox" checked={on} onChange={toggle} />
        がんばりを いろに はんえいする
      </label>
      <p className="pal-settings-note">
        {on
          ? 'さいきん たくさん あそんだ ことの いろが パルに まざるよ。'
          : 'いまは まっしろな パル。チェックを いれると いろが つくよ。'}
      </p>
    </section>
  );
}
